import React from "react"

export const AccesDirectContext = React.createContext({
  isAccesDirectOpen: false,
  setIsAccesDirectOpen: () => {},
})
